
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-tutor",
      function () {
        return require("private-next-pages/ai-tutor/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-tutor"])
      });
    }
  